<template>
  <Content class="overview">
    <FlexContainer>
      <FlexItem :grow="true">
        <FlexContainer justifyContent="start">
          <FlexItem padding="normal">
            <Field label="Live">
              <SelectInput
                v-model="productLive"
                :options="liveOptions"
                placeholder="All"
              />
            </Field>
          </FlexItem>
          <FlexItem padding="normal" v-if="false">
            <SelectFilter
              trait="live"
              :options="liveOptions"
              @onChange="setFilter"
              placeholder="All"
            />
          </FlexItem>
          <FlexItem padding="normal" v-if="false">
            <CheckboxFilter
              type="checkbox"
              filterKey="image"
              :filterOptions="liveOptions"
              :showSingleOption="true"
            />
          </FlexItem>
          <FlexItem padding="normal" v-if="false">
            <Field label="Num Deals" type="black">
              <TextInput
                v-model.trim="productFilter"
                placeholder="0 - 9999"
                @input="setFilter"
              />
            </Field>
          </FlexItem>
          <FlexItem padding="normal" v-if="false">
            <Field label="Publisher" type="black">
              <TextInput
                v-model.trim="productFilter"
                placeholder="John Lewis"
                @input="setFilter"
              />
            </Field>
          </FlexItem>
          <FlexItem padding="normal" v-if="false">
            <SelectFilter
              label="Category"
              :trait="'categoryId'"
              :options="getCategoryOptions"
              @onChange="setFilter"
              placeholder="All Categories"
            />
          </FlexItem>
          <FlexItem padding="normal">
            <Field label="Product" type="black">
              <TextInput
                v-model.trim="productFilter"
                placeholder="Brand, name or colour"
              />
            </Field>
          </FlexItem>
        </FlexContainer>
        <div class="results-info">
          <p>Showing {{ orderedProducts.length }} results.</p>
        </div>
        <table>
          <tr>
            <th>Live</th>
            <th></th>
            <th>Deals</th>
            <th>Publishers</th>
            <th>Category</th>
            <th>Brand</th>
            <th>Name</th>
            <th>Edition</th>
            <th>Colour</th>
          </tr>
          <tr :key="index" v-for="(product, index) in orderedProducts">
            <td>
              <i
                v-if="product.live"
                class="fas fa-badge-check u__color--success"
                @click="toggleProductLive(product.id)"
              ></i>
              <i
                v-else
                class="fal fa-badge u__color--success"
                @click="toggleProductLive(product.id)"
              ></i>
            </td>
            <td>
              <ImageItem :src="product.image" width="24px" height="24px" />
            </td>
            <td>{{ getProductDealsCount(product.id) }}</td>
            <td>
              <FlexContainer>
                <FlexItem
                  v-for="(image, index) in getProductDealsPublisherImages(
                    product.id
                  )"
                  :key="index"
                >
                  <ImageItem :src="image" width="24px" />
                </FlexItem>
              </FlexContainer>
            </td>
            <td>{{ getCategoryName(product.categoryId) }}</td>
            <td>
              <b>{{ product.brand }}</b>
            </td>
            <td>{{ product.name }}</td>
            <td>{{ product.edition }}</td>
            <td>{{ product.colour }}</td>
            <td width="15%">
              <FlexContainer>
                <FlexItem>
                  <ButtonIcon
                    type="success"
                    icon="badge"
                    size="small"
                    @onClick="createDealFromProduct(product.id)"
                  />
                </FlexItem>
                <FlexItem>
                  <ButtonIcon
                    type="primary"
                    icon="copy"
                    size="small"
                    @onClick="duplicateProduct(product.id)"
                  />
                </FlexItem>
                <FlexItem>
                  <ButtonIcon
                    type="secondary"
                    icon="edit"
                    size="small"
                    @onClick="editProduct(product.id)"
                  />
                </FlexItem>
                <FlexItem>
                  <ButtonIcon
                    type="primary"
                    icon="trash"
                    size="small"
                    @onClick="
                      confirmDeleteProduct(
                        product.id,
                        `${product.brand} ${product.name} ${product.colour}`
                      )
                    "
                  />
                </FlexItem>
              </FlexContainer>
            </td>
          </tr>
        </table>
      </FlexItem>
    </FlexContainer>
    <Modal :show="showModal.peakDeal" @closeModal="showModal.peakDeal = false">
      <div slot="header">
        <h2>Peak Deal</h2>
      </div>
      <div slot="body"></div>
    </Modal>
    <Modal :show="showModal.deal" @closeModal="showModal.deal = false">
      <div slot="header">
        <h2>{{ formMode.deal }} Deal</h2>
      </div>
      <div slot="body">
        <DealForm
          :mode="formMode.deal"
          :dealId="currentDeal"
          :productId="currentProduct"
          @onSubmit="onSubmit('deal')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.product" @closeModal="showModal.product = false">
      <div slot="header">
        <h2>{{ formMode.product }} Product</h2>
      </div>
      <div slot="body">
        <ProductForm
          :mode="formMode.product"
          :productId="currentProduct"
          @onSubmit="onSubmit('product')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.category" @closeModal="showModal.category = false">
      <div slot="header">
        <h2>Edit Category</h2>
      </div>
      <div slot="body">
        <CategoryForm
          :categoryId="currentCategory"
          @onSubmit="onSubmit('category')"
        />
      </div>
    </Modal>
    <Modal
      :show="showModal.publisher"
      @closeModal="showModal.publisher = false"
    >
      <div slot="header">
        <h2>Edit Publisher</h2>
      </div>
      <div slot="body">
        <PublisherForm
          :publisherId="currentPublisher"
          @onSubmit="onSubmit('publisher')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.delete" @closeModal="showModal.delete = false">
      <div slot="header">
        <h2>Are you sure you want to delete {{ currentDeletionItem.name }}?</h2>
      </div>
      <div slot="footer">
        <Button type="secondary" @onClick="showModal.delete = false"
          >Cancel</Button
        >
        <Button
          v-show="currentDeletionItem.type === 'deal'"
          type="primary"
          @onClick="
            deleteDeal(currentDeletionItem.id);
            showModal.delete = false;
          "
          >Confirm</Button
        >
        <Button
          v-show="currentDeletionItem.type === 'product'"
          type="primary"
          @onClick="
            deleteProduct(currentDeletionItem.id);
            showModal.delete = false;
          "
          >Confirm</Button
        >
      </div>
    </Modal>
  </Content>
</template>

<script>
import Vue from 'vue';
import { filter, forEach, isEmpty, uniqBy, orderBy } from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import DealForm from '@/components/admin/DealForm';
import ProductForm from '@/components/admin/ProductForm';
import CategoryForm from '@/components/admin/CategoryForm';
import PublisherForm from '@/components/admin/PublisherForm';

export default {
  data: function() {
    return {
      showModal: {
        deal: false,
        product: false,
        category: false,
        publisher: false,
        delete: false,
      },
      formMode: {
        deal: 'add',
        product: 'add',
        category: 'add',
        publisher: 'add',
      },
      currentDeal: null,
      currentProduct: null,
      currentCategory: null,
      currentPublisher: null,
      currentDeletionItem: {},
      productFilter: '',
      dealFilter: '',
      productLive: null,
      liveOptions: [
        {
          text: 'Live',
          value: true,
        },
        {
          text: 'Not Live',
          value: false,
        },
      ],
      imageOptions: [
        {
          text: 'Has Image',
          value: true,
        },
        {
          text: 'No Image',
          value: true,
        },
      ],
      filters: {
        // brand: {
        //   key: 'brand',
        //   operator: '=',
        //   values: ['Silver Cross'],
        // },
        // live: {
        //   key: 'live',
        //   operator: '=',
        //   values: [true],
        // },
        // image: {
        //   key: 'image',
        //   operator: '!empty',
        // },
        // image: {
        //   key: 'image',
        //   operator: 'empty',
        // },
        // dealsCount: {
        //   key: 'dealsCount',
        //   operator: '=>',
        //   values: [1],
        // },
      },
    };
  },
  components: {
    DealForm,
    ProductForm,
    CategoryForm,
    PublisherForm,
  },
  computed: {
    ...mapState({
      deals: (state) => state.deal.deals,
      products: (state) => state.product.products,
      categories: (state) => state.category.categories,
      publishers: (state) => state.publisher.publishers,
    }),
    ...mapGetters({
      getCategoryOptions: 'category/getCategoryOptions',
      // Not Confirmed
      getPublisher: 'publisher/getPublisher',
      getPublisherImage: 'publisher/getImage',
      getCategoryName: 'category/getName',
      getProduct: 'product/getProduct',
      getProductImage: 'product/getImage',
      getProductDealsCount: 'deal/getProductDealsCount',
      getProductDealsPublisherImages: 'deal/getProductDealsPublisherImages',
      getProductDealsInfo: 'deal/getProductDealsInfo',
    }),
    orderedProducts() {
      // let combinedProducts = {};
      let products = this.products;
      // console.log('orderProders');

      // forEach(products, (product, index) => {
      //   if (isEmpty(combinedProducts[`${product.brand} ${product.name}`])) {
      //     combinedProducts[`${product.brand} ${product.name}`] = {
      //       name: `${product.brand} ${product.name}`,
      //       image: product.image,
      //       shorturl: product.shorturl,
      //       dealCount: 0,
      //       lowestPrice: 0,
      //       highestPrice: 0,
      //       products: [],
      //     };
      //   }

      //   combinedProducts[`${product.brand} ${product.name}`].products.push(
      //     product
      //   );
      // });

      // forEach(combinedProducts, (product) => {
      //   let dealInfo = this.getProductDealsInfo(
      //     product.products.map((p) => p.id)
      //   );
      //   if (dealInfo) {
      //     product.dealCount = dealInfo.count;
      //     // @TODO: Update with real lowest and highest price
      //     product.lowestPrice = dealInfo.price;
      //     product.highestPrice = dealInfo.price;
      //     product.publishers = dealInfo.publishers;
      //   }
      // });

      // forEach(this.filters, (f) => {
      //   console.log('f', f);
      //   // if (f.values) {
      //   products = filter(products, (product) => {
      //     switch (f.operator) {
      //       case '=':
      //         console.log(
      //           f.values,
      //           product[f.key],
      //           f.values.indexOf(product[f.key])
      //         );
      //         return f.values.indexOf(product[f.key]) != -1;
      //       case '<':
      //         return f.values.some((el) => product[f.key] < el);
      //       case '>':
      //         return f.values.some((el) => product[f.key] > el);
      //       case 'contains':
      //         return f.values.indexOf(product[f.key]) != -1;
      //       case 'empty':
      //         return isEmpty(product[f.key]);
      //       case '!empty':
      //         return !isEmpty(product[f.key]);
      //     }
      //   });
      //   // }
      // });

      products = filter(products, (product) => {
        if (isEmpty(this.productLive)) {
          return true;
        }

        if (typeof product.live === 'undefined') {
          return false;
        }

        return product.live.toString() === this.productLive;
      });

      products = filter(products, (product) => {
        if (this.productFilter.length === 0) {
          return true;
        }

        let productFullName = `${product.brand} ${product.name} ${product.edition} ${product.colour}`;
        return (
          productFullName
            .toLowerCase()
            .indexOf(this.productFilter.toLowerCase()) !== -1
        );
      });
      return orderBy(products, ['brand', 'name'], ['asc', 'asc']);
    },
  },
  methods: {
    ...mapActions({
      toggleProductLive: 'product/toggleLive',
      toggleDealLive: 'deal/toggleLive',
      deleteDeal: 'deal/deleteDeal',
      deleteProduct: 'product/deleteProduct',
    }),
    setFilter({ key, value }) {
      let filters = this.filters;
      let filter = {
        key,
        operator: '=',
        values: [value],
      };
      console.log('set', filter);
      if (filter.values.length) {
        Vue.set(this.filters, key, filter);
      }
    },
    unsetFilter(state, filter) {
      delete this.filters[filter.key];
    },
    onChangeTab(index) {
      this.currentTab = index;
    },
    onSubmit(type) {
      setTimeout(() => {
        this.showModal[type] = false;
      }, 2000);
    },
    createDealFromProduct(id) {
      this.formMode.deal = 'add';
      this.currentProduct = id;
      this.currentDeal = null;
      this.showModal.deal = true;
    },
    duplicateProduct(id) {
      this.formMode.product = 'duplicate';
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editDeal(id) {
      this.formMode.deal = 'edit';
      this.currentDeal = id;
      this.showModal.deal = true;
    },
    peakDeal(url) {
      this.currentDeal = url;
      this.showModal.peakDeal = true;
    },
    editProduct(id) {
      this.formMode.product = 'edit';
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editCategory(id) {
      this.currentCategory = id;
      this.showModal.category = true;
    },
    editPublisher(id) {
      this.currentPublisher = id;
      this.showModal.publisher = true;
    },
    confirmDeleteProduct(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: 'product',
        id,
        name,
      };
    },
    confirmDeleteDeal(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: 'deal',
        id,
        name,
      };
    },
    deletePublisher() {},
    getProductName(productId) {
      let product = this.getProduct(productId);

      if (product) {
        return `${product.brand} ${product.name} ${product.edition || ''} ${
          product.colour
        }`;
      }
      return 'Name not found';
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  background: $white;
  padding: $padding;
}

.results-info {
  padding: $padding-small 0;
  font-weight: 400;
}

table {
  width: 100%;

  tr:nth-of-type(2n) {
    background: $gray-lightest;
  }

  th,
  td {
    padding: 0.8rem;
    vertical-align: middle;
  }

  th {
    font-weight: 400;
  }
}
</style>
